import type React from 'react';
import { ProjectPropertyBentoCard } from '@/components/ProjectPropertyBentoCard';
import { PROJECT_PROPERTY_TABLES } from '@/lib/projectPropertiesConfig';

export const ProjectPropertiesPage: React.FC = () => {
  return (
    <div className="p-2">
      <div className="mb-6">
        <h1 className="m-0 text-xl font-semibold text-primary">Project Properties</h1>
        <p className="mt-1 text-sm text-text-secondary">
          Reference data for projects, expenses, and delivery options.
        </p>
      </div>
      <div className="grid grid-cols-2 auto-rows-[minmax(180px,auto)] gap-4 lg:grid-cols-4">
        {PROJECT_PROPERTY_TABLES.map((config) => (
          <ProjectPropertyBentoCard key={config.key} config={config} />
        ))}
      </div>
    </div>
  );
};
